import React, { ReactElement } from "react";
import { Box, BoxProps } from "@mantine/core";
import DOMPurify from "dompurify";

interface SafeHTMLProps extends BoxProps {
	content: string;
	openLinksInNewTab?: boolean;
}

export function SafeHTML({
	content,
	openLinksInNewTab = false,
	...boxProps
}: SafeHTMLProps): ReactElement {
	if (openLinksInNewTab) {
		DOMPurify.addHook("afterSanitizeAttributes", (node) => {
			if (node.tagName === "A") {
				node.setAttribute("target", "_blank");
				node.setAttribute("rel", "noopener noreferrer");
			}
		});
	}

	const cleanHTML = DOMPurify.sanitize(content);
	return <Box {...boxProps} dangerouslySetInnerHTML={{ __html: cleanHTML }} />;
}
